import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilterStatus } from '../slices/todoSlice'
import Button, { SelectButton } from './Button'
import TodoModel from './TodoModel'

function AppHeader() {
    const [modelOpen, setModelOpen] = useState(false)
    const initialFilterStatus = useSelector((state) => state.todo.filterStatus)
    const [filterStatus, setFilterStatus] = useState(initialFilterStatus)
    const dispatch = useDispatch()

    const updateFilter = (e) => {
      setFilterStatus(e.target.value)
      dispatch(updateFilterStatus(e.target.value))
    }

  return (
    <div className='flex justify-between items-center h-[60px] ml-8 mr-8'>
        
        <Button onClick={() => setModelOpen(true)}>Add Task</Button>
        <SelectButton id='status' value={filterStatus} onChange={(e) => updateFilter(e)}>
            
            <option value='all'>All</option>
            <option value='incomplete'>Incomplete</option>
            <option value='complete'>Complete</option>
        </SelectButton>
        <TodoModel type='add' modelOpen={modelOpen} setModelOpen={setModelOpen}/>
    </div>
  )
}

export default AppHeader